export default __webpack_public_path__ + "static/media/chris-mcauley-headshot.7028e329.png";